import Immutable, { Map, Iterable, fromJS } from 'immutable';

export const LOAD_CLIENTS = 'LOAD_CLIENTS';
export const UNLOAD_CLIENTS = 'UNLOAD_CLIENTS';
export const UPDATE_CLIENTS = 'UPDATE_CLIENTS';
export const LOAD_SINGLE_CLIENT = 'LOAD_SINGLE_CLIENT';
export const UPDATE_SINGLE_CLIENT = 'UPDATE_SINGLE_CLIENT';


export default function ClientsReducer(state, action) {

    switch(action.type) {

        case LOAD_CLIENTS:
        case UPDATE_SINGLE_CLIENT:

            if(action.loading) {
                state = state.setIn(['loading'], true);
            }

            if(action.collection) {
                state = state.setIn(['collection'], Immutable.fromJS(action.collection).groupBy(x => x.get('id')).map(x => x.first()))
            }

            if(action.lastSynced) {
                state = state.setIn(['lastSynced'], action.lastSynced);
            }

            if(action.single) {
                state = state.setIn(['single'], Iterable.isIterable(action.single) ? action.single : Immutable.fromJS(action.single))
            }

            return state;
        case UNLOAD_CLIENTS:

            return state;
        case UPDATE_CLIENTS:

            return state;
        case LOAD_SINGLE_CLIENT:

            return state;
        case UPDATE_SINGLE_CLIENT:
            if(action.single) {
                state = state.setIn(['single'], Iterable.isIterable(action.single) ? action.single : Immutable.fromJS(action.single))
            }
            return state;

        default:

    }

    return state || Map();

}